
import { Component, Vue, Prop } from "vue-property-decorator";

type SettingList = {
	show: number,
	level: number,
}

@Component
export default class SettingDebug extends Vue
{
	@Prop(String) readonly settingsJsonString: string | undefined;

	settings: SettingList | null = null;

	parse()
	{
		console.log("SettingDebug:jsonstring", this.settingsJsonString);
		if(!this.settingsJsonString)
		{
			return;
		}

		const parsed: SettingList = JSON.parse(this.settingsJsonString);
		console.log("SettingDebug:jsonstring:parsed", parsed);

		this.settings = parsed;
	}

	// updated()
	// {
	// 	this.parse();
	// }
	
	changed()
	{
		this.$emit("updated", "debug", JSON.stringify(this.settings));
	}

	mounted()
	{
		this.parse();
	}
}
